module.exports = __webpack_public_path__ + "img/pause.0f0f11da.svg";